<template lang="html">
	<div class="campaign-type-filter__search" @keydown.esc="clearFilters">
		<input
			placeholder="Search Templates..."
			type="text"
			class="omapi-input"
			:value="search"
			@input="updateSearch"
			@keydown.esc="clearSearch"
		/>
		<svg-times v-if="search" class="clear-search" @click="clearSearch" />
	</div>
</template>

<script lang="js">
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('templates')

export default {
	computed : {
		...mapState([ 'search' ]),
	},
	methods : {
        /**
         * Clear the search value in state.
         *
         * @returns {void}
         */
		clearSearch () {
			this.$store.commit('templates/setSearch', '')
		},
        /**
         * Update the search value in state.
         *
         * @param {Event} e The input event.
         *
         * @returns {void}
         */
		updateSearch (e) {
			this.$store.commit('templates/setSearch', e.target.value)
		},
	},
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.campaign-type-filter__search {
	position: relative;
	width: 278px;

	@media screen and (max-width: 990px) {
		width: 155px;
	}

	svg {
		position: absolute;
		right: 8px;
		top: 50%;
		margin-top: -6.5px;
		width: 13px;
		height: 13px;

		&.clear-search {
			cursor: pointer;
		}
	}

	.omapi-input[type='text'] {
		width: 100%;
		height: 40px;
		padding-right: 24px;
		margin: 0;

		&:focus {
			border-color: #2271b1;
			box-shadow: none;
		}
	}
}
</style>
